<template>
    <div :class="wrapSize">
        <div v-if="label" :class="labelWrap">
            <label :for="labelFor" class="inline-block text-80 leading-tight">{{ label }}</label>
        </div>
        <DateTimePicker
            class="w-full"
            :timestamp="parseInt(value, 10)"
            :enable-time="displayTime"
            :enable-seconds="false"
            :placeholder="placeholder"
            @input.prevent=""
            @change="handleChange"
        />
    </div>
</template>

<script>
  import DateTimePicker from '@/_legacy/components/DateTimePicker.vue';

  export default {
    name: 'InputControlDate',

    components: { DateTimePicker },

    props: {
      wrapSize: {
        type: String,
        default: 'mb-6',
      },
      labelWrap: {
        type: String,
        default: 'mb-2',
      },
      label: {
        type: String,
        default: '',
      },
      labelFor: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      displayTime: {
        type: Boolean,
        default: false,
      },
      initialValue: {
        type: Number,
        default: null,
      },
      value: {
        type: [String, Number],
        default: null,
      },
      inputClass: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },

    methods: {
      handleChange(value) {
        this.$emit('input', value);
      },
    },

  };
</script>
